import { createActions } from 'redux-actions'

const { picturesPopupStatus } = createActions({
  PICTURES_POPUP_STATUS: data => ({ data })
})

const setPicturesPopupStatus = status => dispatch => dispatch(picturesPopupStatus({ status }))

export { setPicturesPopupStatus, picturesPopupStatus }
